import {EventLog} from "../Event/EventLog";
import {ITestingContext} from "./ITestingContext";
import {BaseTestResultData} from "./BaseTestResultData";

// not sure if it's needed.
export class TestResultData implements ITestingContext {
    // we might need to break this up and store separate.
    items: BaseTestResultData[] = [];
    logs: EventLog[] = [];

    addTestResultItem(item: BaseTestResultData): void {
        this.items.push(item);
    }

    addLogItem(item: EventLog): void {
        this.logs.push(item);
    }

    addLogItems(items: EventLog[]): void {
        this.logs.push(...items);
    }
}
